import { ICustomerForecastDiffLastMonthForecastData } from '../entities/customerForecastDiffLastMonth';

/**
 * 内示前月差異情報を生成するファクトリ
 */
export class ICustomerForecastDiffLastMonthForecastDataFactory {
  /**
   * 内示前月差異の内示情報を生成する
   * @param initialData - 初期値
   */
  public static create(initialData: Partial<ICustomerForecastDiffLastMonthForecastData> = {}): ICustomerForecastDiffLastMonthForecastData {
    const customerForecastDiffLastMonthForecastData: ICustomerForecastDiffLastMonthForecastData = {
      receivedYearMonth: initialData.receivedYearMonth ?? { year: -1, month: -1 },
      targetYearMonth: initialData.targetYearMonth ?? { year: -1, month: -1 },
      lastMonthAmount: initialData.lastMonthAmount,
      currentMonthAmount: initialData.currentMonthAmount,
      diffAmount: initialData.diffAmount,
      customerForecastUpdateAt: initialData.customerForecastUpdateAt,
    };
    return customerForecastDiffLastMonthForecastData;
  }
}
